<template>
  <div class="container">

    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>お取引履歴のご確認</heading-one>
    <p>過去6ヵ月間のお借り入れ・ご返済の履歴を確認することができます。</p>
    <small>※反映はご利用いただいた日の翌日以降となります。</small>
    <section>
      <tab-filled class="-tab-orange _mt-40" :active="selectedYyyymm">
        <tab-header class="-sm -arrow _mb-md-60 _mb-sm-40">
          <tab-item v-for="(monthDate, index) of yearMonthList" :tabName="dateToyyyyMmStr(monthDate)" :key="index" @onclick="setTab">{{yyyyMmJpDateFormat(monthDate)}}</tab-item>
        </tab-header>

        <notice-box class="-cancel _mb-md-60 _mb-sm-40">
          <notice-body>
            <btngroup-radio class="-center" >
              <btn-radio id="type1" name="type" value="all" class="_mr-md-40 _mr-sm-10" v-model="displayType" variant="-xs">お借り<br class="-pcnone" />入れ／<br/>ご返済</btn-radio>
              <btn-radio id="type2" name="type" value="disbursal" class="_mr-md-40 _mr-sm-10" v-model="displayType" variant="-xs">お借り<br class="-pcnone" />入れ</btn-radio>
              <btn-radio id="type3" name="type" value="payment" class="_mr-md-0 _mr-sm-0" v-model="displayType" variant="-xs">ご返済</btn-radio>
            </btngroup-radio>
          </notice-body>
        </notice-box>

        <template v-if="hasTransactionList">
          <tab-body v-for="(monthDate, index) of yearMonthList" :tabName="dateToyyyyMmStr(monthDate)" :key="'tab0' + (index + 1)" class="_pl-0 _pr-0">
            <chart-group class="_mb-md-60 _mb-sm-30">
              <chart-box>
                <chart-header class="-dark">
                  <chart-row>
                    <chart-data class="-sm">お取引日</chart-data>
                    <chart-data class="-justify-3 -spfix-27">お取引種別</chart-data>
                    <chart-data class="-justify-3 -spfix-35">お取引方法</chart-data>
                    <chart-data class="-justify-3 -spfix-25">お取引金額</chart-data>
                  </chart-row>
                </chart-header>
                <chart-body class="-pc-left -sp-left">
                  <chart-row v-for="(transaction, index) in showTransactionList" :key="index">
                    <!--日付-->
                    <chart-data v-show="transaction.type === 'disbursal'" class="heading -sp-center">{{transaction.disbursal_date || '' | ymdDateFormat('/')}}</chart-data>
                    <chart-data v-show="transaction.type === 'payment'" class="heading -sp-center">{{transaction.transaction_date || '' | ymdDateFormat('/')}}</chart-data>
                    <!--区分-->
                    <chart-data :class="'-' + transaction.type">{{transaction.type === 'disbursal' ? 'お借り入れ' : 'ご返済'}}</chart-data>
                    <!--お取引方法-->
                    <chart-data v-show="transaction.type === 'disbursal'" class="-sp-center">{{showDisbursalType(transaction)}}</chart-data>
                    <chart-data v-show="transaction.type === 'payment'" class="-sp-center">{{showPaymentType(transaction)}}</chart-data>
                    <!--お取引金額-->
                    <chart-data v-show="transaction.type === 'disbursal'" class="-pc-right -sp-right">{{transaction.disbursed_amt | numberToCurrency}} </chart-data>
                    <chart-data v-show="transaction.type === 'payment'" class="-pc-right -sp-right">{{transaction.transaction_amount | numberToCurrency}} </chart-data>
                  </chart-row>
                </chart-body>
              </chart-box>
            </chart-group>

            <!-- マンスリーステートメントあり -->
            <template v-if="selectedReport">
              <list-group class="-link">
                <list-item href='#' class="-link" @click.prevent="showPdf()" :key="'report'+index">
                  <a href="#" class="atag">
                    <element-box class="-center">
                      <heading-icon class="_mb-0">
                        <p class="heading _mb-0">当月のご利用履歴（マンスリーステートメント）ダウンロード</p>
                        <icon-box src="pdf" class="icon -sm _ml-sm-5 _ml-md-10"></icon-box>
                      </heading-icon>
                    </element-box>
                  </a>
                </list-item>
              </list-group>
            </template>
            <!-- マンスリーステートメントなし -->
            <template v-else>
              <p class="_mt-sm-15 _mt-md-30">※当月のご利用履歴（マンスリーステートメント）のダウンロードは、翌月11日頃にご覧いただけます。</p>
            </template>
            <template v-if="selectedOverLimitFlag">
              <p class="_mt-sm-15 _mt-md-30">
                ※表示可能なお取引は100件です。詳しくは当月のご利用履歴（マンスリーステートメント）をご確認いただくか、または、
                <btn-text routerName="sv036" class="-underline" target="_blank">コールセンター</btn-text>
                へお問い合わせください。
              </p>
            </template>

          </tab-body>
        </template>
        <template v-else>
          <p>※該当するお取引がありません。</p>
        </template>
      </tab-filled>

      <btngroup-single class="_mt-sm-30 _mt-md-120 _mb-sm-30 _mb-md-120">
        <btn-main class="-normal" routerName="mb001">会員さま専用サイトトップへ</btn-main>
      </btngroup-single>
    </section>

  </div><!-- container -->
</template>

<script>
import { getPdfFileLambdaInvoke, tradingHistoryLambdaInvoke, getUserSessionLambdaInvoke, apiGetPdfFile } from '../utils/LambdaHelper'
import { dateToyyyyMmStr } from '../utils/DateHelper'

import HeadingOne from '../components/heading/HeadingOne'
import TabFilled from '../components/tabs/TabFilled'
import TabHeader from '../components/tabs/TabHeader'
import TabItem from '../components/tabs/TabItem'
import TabBody from '../components/tabs/TabBody'
import NoticeBox from '../components/box/NoticeBox'
import NoticeBody from '../components/box/NoticeBody'
import BtngroupRadio from '../components/button/BtngroupRadio'
import BtnRadio from '../components/button/BtnRadio'
import ChartGroup from '../components/charts/ChartGroup'
import ChartBox from '../components/charts/ChartBox'
import ChartHeader from '../components/charts/ChartHeader'
import ChartRow from '../components/charts/ChartRow'
import ChartData from '../components/charts/ChartData'
import ChartBody from '../components/charts/ChartBody'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import ElementBox from '../components/elements/element-box'
import IconBox from '../components/icons/icon-box'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import HeadingIcon from '../components/heading/HeadingIcon'
import BtnText from '../components/button/BtnText'
export default {
  name: 'mb-004',
  metaInfo: {
    title: 'お取引履歴のご確認｜ご契約・お取引情報',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お取引履歴'}
    ]
  },
  components: {
    BtnText,
    HeadingIcon,
    BtnMain,
    BtngroupSingle,
    IconBox,
    ElementBox,
    ListItem,
    ListGroup,
    ChartBody,
    ChartData,
    ChartRow,
    ChartHeader,
    ChartBox,
    ChartGroup,
    BtnRadio,
    BtngroupRadio,
    NoticeBody,
    NoticeBox,
    TabBody,
    TabItem,
    TabHeader,
    TabFilled,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'お取引履歴のご確認',
        active: true
      }
      ],
      displayType: 'all',
      yearMonthList: [],
      transactionList: [],
      transactionDisbursalList: [],
      transactionPaymentList: [],
      selectedYyyymm: dateToyyyyMmStr(new Date()),
      pdfList: [],
      reportMap: {},
      overLimitMap: {},
      userSessionData: {
        user_session: '',
        state: ''
      }
    }
  },
  mounted () {
    for (let i = 0; i < 6; i++) {
      // 月末近くなるとバグるので、毎月1日をセットする
      let dt = new Date()
      dt.setDate(1)
      let targetMonth = new Date(dt.setMonth(dt.getMonth() - i))
      this.yearMonthList.push(targetMonth)
    }

    for (let yearMonth of this.yearMonthList) {
      let targetYyyymm = dateToyyyyMmStr(yearMonth)
      tradingHistoryLambdaInvoke(targetYyyymm, targetYyyymm).then(res => {
        let resBody = JSON.parse(res.body)
        for (let key in resBody) {
          if (key === 'disbursal_transaction') {
            for (let transaction of resBody['disbursal_transaction']) {
              transaction['yyyymm'] = targetYyyymm
              transaction['type'] = 'disbursal'
              transaction['ctf_no'] = transaction['ctf_no_disbursal']
              this.transactionDisbursalList.push(transaction)
            }
          }
          if (key === 'payment_transaction') {
            for (let transaction of resBody['payment_transaction']) {
              transaction['yyyymm'] = targetYyyymm
              transaction['type'] = 'payment'
              transaction['ctf_no'] = transaction['ctf_no_payment']
              this.transactionPaymentList.push(transaction)
            }
          }
          if (key === 'over_limit_flg') {
            this.overLimitMap[targetYyyymm] = resBody['over_limit_flg']
          }
        }
        if (this.displayType === 'all') {
          this.transactionList = this.transactionDisbursalList.concat(this.transactionPaymentList)
        } else if (this.displayType === 'disbursal') {
          this.transactionList = this.transactionDisbursalList
        } else if (this.displayType === 'payment') {
          this.transactionList = this.transactionPaymentList
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
      let report = {
        monthly_statement_year: dateToyyyyMmStr(yearMonth),
        report_type: '04'
      }
      getPdfFileLambdaInvoke(report).then(res => {
        let resBody = JSON.parse(res.body)
        if (resBody.file_data) {
          this.$set(this.reportMap, dateToyyyyMmStr(yearMonth), dateToyyyyMmStr(yearMonth))
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    }
    getUserSessionLambdaInvoke().then(res => {
      for (let key in res) {
        if (this.userSessionData.hasOwnProperty(key)) {
          this.userSessionData[key] = res[key]
        }
      }
    }).catch(error => {
      this.goToErrorPage(error)
    })
  },
  methods: {
    yyyyMmJpDateFormat (date) {
      return date.getFullYear() + '年' + (date.getMonth() + 1) + '月'
    },
    dateToyyyyMmStr (date) {
      return date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2)
    },
    setTab (tabName) {
      this.selectedYyyymm = tabName
    },
    showDisbursalType (transaction) {
      switch (transaction.disbursal_type) {
        case '9':
          return 'セブン銀行スマホATM'
        case 'D':
          return 'au PAY 残高にチャージ'
        case '4':
          return 'ご登録口座へのお振込み'
        default:
          return ''
      }
    },
    showPaymentType (transaction) {
      switch (transaction.payment_type) {
        case '9':
          return 'セブン銀行スマホATM'
        case 'A':
          return 'ご登録口座からの引落し'
        case '4':
          return '指定口座へのお振込み'
        default:
          return ''
      }
    },
    showPdf () {
      const userSession = this.userSessionData['user_session']
      const state = this.userSessionData['state']
      const reportType = '04'
      const monthlyStatementYear = this.selectedReport

      apiGetPdfFile({user_session: userSession, report_type: reportType, monthly_statement_year: monthlyStatementYear, state: state}).then(res => {
        window.open(`${process.env.GET_PDF_FILE}?user_session=${userSession}&report_type=${reportType}&monthly_statement_year=${monthlyStatementYear}&state=${state}`, '_blank')
      }).catch(error => {
        this.goToErrorPage(error)
      })
    }
  },
  computed: {
    hasTransactionList () {
      let result = []
      for (let transaction of this.transactionList) {
        if (transaction.yyyymm === this.selectedYyyymm) {
          if (this.displayType === 'all' || this.displayType === transaction.type) {
            result.push(transaction)
          }
        }
      }
      return result.length > 0
    },
    showTransactionList () {
      let result = []
      for (let transaction of this.transactionList) {
        if (transaction.yyyymm === this.selectedYyyymm) {
          if (this.displayType === 'all' || this.displayType === transaction.type) {
            result.push(transaction)
          }
        }
      }
      return result.sort(function (a, b) {
        if (parseInt(a.ctf_no) < parseInt(b.ctf_no)) return 1
        if (parseInt(a.ctf_no) > parseInt(b.ctf_no)) return -1
        return 0
      })
    },
    selectedReport () {
      return this.reportMap[this.selectedYyyymm]
    },
    selectedOverLimitFlag () {
      return this.overLimitMap[this.selectedYyyymm] === '1'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

  .heading-icon {
    text-align: left !important;
    justify-content: left !important;
    .heading {
      font-size: 14px !important;
      @include mq-up(md) {
        font-size: 16px !important;
      }
    }
  }
  .notice-box {
    @include mq-down(md) {
      padding: 10px !important;
    }
    @include mq-down(xs) {
      padding: 10px 3px !important;
    }
  }
  .btngroup-radio {
    @include flex(flex,center,center,row,nowrap);
    >.btn-radio:nth-of-type(1) {
      @include mq-down(md) {
        line-height: 110%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Mb004.vue